"use client";
import {
  Footer as BaseFooter,
  type FooterProps as BaseFooterProps,
} from "../Base/Footer";

interface FooterProps extends BaseFooterProps {
  leftChildren?: React.ReactNode;
  rightChildren?: React.ReactNode;
  copyright?: boolean;
  title?: string;
}

export const Footer = ({
  leftChildren,
  rightChildren,
  copyright,
  title,
  ...props
}: FooterProps) => {
  return (
    <BaseFooter {...props}>
      <div className="flex flex-row h-12">
        {copyright && (
          <div className="mr-1">&copy; {new Date().getFullYear()}</div>
        )}
        {title && <div>{title}</div>}
      </div>
      {leftChildren}
      <div className="flex-grow"></div>
      {rightChildren}
    </BaseFooter>
  );
};
